import { render, staticRenderFns } from "./ModelEditor.vue?vue&type=template&id=e9918d02&scoped=true&"
import script from "./ModelEditor.vue?vue&type=script&lang=ts&"
export * from "./ModelEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ModelEditor.vue?vue&type=style&index=0&id=e9918d02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9918d02",
  null
  
)

export default component.exports